module.exports = __webpack_public_path__ + "img/landing.a5b03da0.jpg";